import Typography from '@/components/UI/typography/Typography';
import styles from './HousesCarousel.module.scss';
import { FC, ReactNode, useRef } from 'react';
import { ProductListRecord } from '@/components/reusable/productCard/types';
import Link from 'next/link';
import Icon from '@/components/UI/icon/Icon';
import Box from '@/components/UI/box/Box';
import HouseCarouselSkeleton from './houseCarouselSkeleton/HouseCarouselSkeleton';
import dynamic from 'next/dynamic';
import useIntersection from '@/hooks/useIntersection';
import HousesCarouselComponent from './housesCarouselComponent/HousesCarouselComponent';

// const HousesCarouselComponent = dynamic(
//   () => import('./housesCarouselComponent/HousesCarouselComponent'),
//   {
//     ssr: false,
//     loading: HouseCarouselSkeleton,
//   },
// )

interface HousesCarouselProps {
  title: string;
  list: ProductListRecord[];
  href: string;
  description: string;
  lateNight?: boolean;
  children?: ReactNode;
}
const HousesCarousel: FC<HousesCarouselProps> = ({
  title,
  list,
  href,
  description,
  children,
  lateNight
}) => {
  const ref = useRef(null);
  // const isVisible = useIntersection(ref, '100px', true)

  return <Box component={'section'} className={styles['houses-carousel']} ref={ref} data-sentry-element="Box" data-sentry-component="HousesCarousel" data-sentry-source-file="HousesCarousel.tsx">
      <Box component={'header'} className={styles['houses-carousel-header']} data-sentry-element="Box" data-sentry-source-file="HousesCarousel.tsx">
        <Typography variant="bodyL_Bold" component={'h2'} data-sentry-element="Typography" data-sentry-source-file="HousesCarousel.tsx">
          {title}
        </Typography>
        {children}
        <Link href={href} className={styles['houses-carousel-showAllLink']} data-sentry-element="Link" data-sentry-source-file="HousesCarousel.tsx">
          {description}
          <Icon name="arrow-left-1" type="primary" size="small" data-sentry-element="Icon" data-sentry-source-file="HousesCarousel.tsx" />
        </Link>
      </Box>
      {/* {isVisible && ( */}
      <HousesCarouselComponent list={list} lateNight={lateNight} data-sentry-element="HousesCarouselComponent" data-sentry-source-file="HousesCarousel.tsx" />
      {/* )} */}
      <Box component={'footer'} className={styles['houses-carousel-footer']} data-sentry-element="Box" data-sentry-source-file="HousesCarousel.tsx">
        <Link href={href} className={styles['houses-carousel-showAllLink']} data-sentry-element="Link" data-sentry-source-file="HousesCarousel.tsx">
          {description}
          <Icon name="arrow-left-1" type="primary" size="small" data-sentry-element="Icon" data-sentry-source-file="HousesCarousel.tsx" />
        </Link>
      </Box>
    </Box>;
};
export default HousesCarousel;